import { FDBodyText } from '@facet-wealth/design';
import React from 'react';
import PropTypes from 'prop-types';

export const CodeSentText = ({ value }) => {
  return (
    <FDBodyText
      value={`We sent a code to: ${value}`}
    />
  );
};

CodeSentText.propTypes = {
  value: PropTypes.string.isRequired,
};
